/**
 * CDN entry point for the Vaisala Hanko Menu.
 *
 * This file registers the <vaisala-hanko-menu> Custom Element so that
 * it can be used by including a single <script> tag — no build step
 * or additional dependencies required on the host page.
 *
 * The @font-face import ensures "Vaisala Sans VF" is bundled into the
 * extracted CSS so the CDN consumer doesn't need to load fonts separately.
 */
import '@vaisala/fonts/vaisala-sans-vf.css';
import { VaisalaHankoMenuElement } from './custom-element/VaisalaHankoMenuElement';

if (!customElements.get('vaisala-hanko-menu')) {
  customElements.define('vaisala-hanko-menu', VaisalaHankoMenuElement);
}

export { VaisalaHankoMenuElement };
